/*
 * @Description: 功能描述
 * @Author: yy
 * @Date: 2019-05-31 14:47:27
 * @LastEditors: yy
 * @LastEditTime: 2020-08-17 15:59:31
 */
import * as d3 from 'd3'
// import baseChart from './customBaseChart'

export default class Chart {
  constructor(selector, opt) {
    Object.assign(this.option, opt)
    this.svg = d3
      .select(selector)
      .append("svg:svg") //在“container”中插入svg
      .attr('id', 'd3chart')
      // .attr("width", option.width) //设置svg的宽度
      // .attr("height", option.height) //设置svg的高度

    this.createPane()
    this.render()
  }

  option = {
    width: 800,
    height: 400,
    top: 100,
    bottom: 90,
    left: 100,
    right: 100,
    barPadding: 2,
    barWidth: 30,
    textOffset: 40,
    lineSpace: 10,
    data: [],
    barMap: {},
    lineMap: {},
    barColor: 'steelblue',
    lineColor: 'cornflowerblue',
    barLabelColor: '#000',
    lineLabelColor: '#000',
  }
  svg = null
  pane = null
  xAxis = null
  xAxisWrapper = null
  yAxisBar = null
  yAxisBarWrapper = null
  yAxisLine = null
  yAxisLineWrapper = null
  bar = null
  line = null

  setLayout () {
    const {width, height} = this.option
    this.svg
      //设置svg的宽度
      .attr("width", width)
      //设置svg的高度
      .attr("height", height) 
  }

  createPane = () => {
    const {
      left,
      top
    } = this.option
    if (!this.pane) {
      this.pane = d3
        .select("svg#d3chart")
        .append("g")
        .attr("transform", `translate(${left}, ${top})`)
    }
  }

  createAxisX = () => {
    const {
      data,
      width,
      left,
      right
    } = this.option
    //把曲线沿x轴按比例放大
    if (!this.xAxis) {
      this.xAxis = d3.scaleBand()        
    }
    this.xAxis
      .range([0, width - left - right])
      .domain(data.map(item => item.title))
  }

  // 创建条形图纵坐标
  createBarAxisY = () => {
    const {
      data,
      height,
      top,
      bottom
    } = this.option
    //把曲线沿y轴按比例放大
    if (!this.yAxisBar) {
      this.yAxisBar = d3.scaleLinear()
    }
    const max = d3.max(data.map(item => item.bar))
    this.yAxisBar
      .domain([0, max])
      .range([height - top - bottom, 0])
  }
  // 创建曲线图坐标
  createLineAxisY = () => {
    const {
      data,
      height,
      top,
      bottom
    } = this.option
    //把曲线沿y轴按比例放大
    if (!this.yAxisLine) {
      this.yAxisLine = d3.scaleLinear()
    }
    const max = d3.max(data.map(item => item.line))
    this.yAxisLine
      .domain([0, max])
      .range([height - top - bottom, 0])

  }

  // 创建条形图
  createBar = () => {
    const {
      pane,
      xAxis,
      yAxisBar
    } = this
    const {
      data,
      width,
      left,
      right,
      barPadding,
      barWidth,
      barColor
    } = this.option
    const dataLen = data.length
    const barPaddingHalf = barPadding / 2
    const _maxW = (width - left - right) / dataLen - barPadding
    const barW = _maxW > barWidth ? barWidth : _maxW
    const barX = (_maxW - barW) / 2

    // console.log(barWidth);

    if (!this.bar) {
      this.bar = pane
        .append('g')
        .attr('class', 'bar')
    }

    const rects = this.bar.selectAll('rect').data(data.map(item => item.bar))
    rects.enter().append("rect").attr("fill", barColor)
    rects.exit().remove()

    this.bar.selectAll('rect')
      .attr("width", barW)
      .attr("height", (d, i) => yAxisBar(0) - yAxisBar(d))
      .attr("x", (d, i) => xAxis(data[i].title) + barPaddingHalf + barX)
      .attr("y", (d, i) => yAxisBar(data[i].bar))
  }

  // 创建曲线图
  createLine = () => {
    const {
      pane,
      xAxis,
      yAxisLine
    } = this
    const {
      data,
      width,
      left,
      right,
      barPadding,
      lineColor
    } = this.option
    const dataLen = data.length
    const barPaddingHalf = barPadding / 2
    const barWidth = (width - left - right) / dataLen - barPadding
    const offset = barPaddingHalf + barWidth / 2

    //d3中绘制曲线的函数
    var line_generator = d3.line()
      .x(function (d, i) {
        return xAxis(data[i].title) + offset
      })
      //曲线中x的值
      .y(function (d) {
        return yAxisLine(d);
      }) //曲线中y的值
      // .curve(d3.curveCardinal)
    // .interpolate("curveCardinal") //把曲线设置光滑

    if (!this.line) {
      this.line = pane.append("path")
        .attr('fill', 'transparent')
        .attr('stroke', lineColor)
        .attr('stroke-width', 2)
    }

    this.line.attr("d", line_generator(data.map(item => item.line)))
  }

  createText (pane, className, xAxis, yAxis, labelMap, color = '#000', type = 'bar') {
    const {
      data,
      width,
      height,
      top,
      left,
      right,
      bottom,
      barPadding,
      textOffset,
      labelLineColor,
      lineSpace
    } = this.option

    // 数据长度
    const dataLen = data.length
    const barPaddingHalf = barPadding / 2
    
    const barWidth = (width - left - right) / dataLen - barPadding
    const offset = barPaddingHalf + barWidth / 2
    const maxBarHeight = height - top - bottom

    const _className = `.${className}`

    if (pane.selectAll(_className).size() === 0) {
      pane.append('g').attr('class', className)
    }

    const lineWrapper = pane
      .selectAll(_className)
      .selectAll('g')
      .data(data.map(item => item[type]))


    const enter = lineWrapper.enter()
    lineWrapper.exit().remove()

    // 新增g元素
    const enterWrap = enter.append('g')
    // 初始化line元素
    enterWrap.append('line')
    // 初始化text元素
    enterWrap.append('text')
      .attr("text-anchor", "middle")
      .call(d3.drag().on("start", function () {
        var text = d3.select(this).classed("dragging", true);
        const line = d3.select(text.node().parentNode).select('line')
        d3.event.on("drag", dragged).on("end", ended);
        function dragged(d) {
          text.raise().attr("transform", `translate(${d3.event.x},${d3.event.y})`)
          line.raise()
            .attr('x1', d3.event.x)
            .attr('y1', d3.event.y + lineSpace)
        }

        function ended() {
          text.classed("dragging", false);
        }
      }))
    
    pane.selectAll(_className)
      .selectAll('line')
      .attr('visibility', (d, i) => {
        return !!labelMap[data[i].title] ? 'visible' : 'collapse'
      })
      .attr('style', (d, i) => {
        return !!labelMap[data[i].title] ? '' : 'display:none'
      })
      .attr('x1', (d, i) => xAxis(data[i].title) + offset)
      .attr('y1', (d, i) => yAxis(data[i][type]) - textOffset + lineSpace)
      .attr('x2', (d, i) => xAxis(data[i].title) + offset)
      // .attr('y2', (d, i) => {
      //   const h = yAxis(data[i][type])
      //   // 如果是条形图连线位置从条形图内部开始
      //   if (type === 'bar') {
      //     return maxBarHeight - h > 20 ? h + 10 : h
      //   }
      //   return h
      // })
      .attr('y2', (d, i) => yAxis(data[i][type]) - lineSpace)
      .attr('stroke', labelLineColor)


    pane.selectAll(_className)
      .selectAll('text')
      .html((val, i) => {
        if (labelMap[data[i].title]) {
          const label = labelMap[data[i].title].label
          return label.split('\\n').map((item, i, arr) => `<tspan x="0" y="${(arr.length - i -1) * -18 }">${item}</tspan>`).join('')
        }
        return ''
      })
      .attr("transform", (d, i) => `translate(${xAxis(data[i].title) + offset},${yAxis(data[i][type]) - textOffset})`)
      .attr('font-size', 16)
      .attr('font-weight', 'bold')
      .attr('font-family', 'PingFang SC')
      .attr('fill', color)

  }

  // 绑定条形图坐标
  bindAxisYBar() {
    const {
      pane,
      yAxisBarWrapper,
      yAxisBar
    } = this

    const axis = d3.axisLeft(yAxisBar)

    if (!yAxisBarWrapper) {
      this.yAxisBarWrapper = pane.append("g")
    }
    this.yAxisBarWrapper.call(axis)
    .attr('font-size', 12)

  }

  // 绑定曲线图坐标
  bindAxisYLine() {
    const {
      pane,
      yAxisLineWrapper,
      yAxisLine
    } = this
    const {
      width,
      left,
      right
    } = this.option

    const axis = d3.axisRight(yAxisLine)

    if (!yAxisLineWrapper) {
      this.yAxisLineWrapper = pane.append("g")
    }
    this.yAxisLineWrapper
      .attr('transform', `translate(${width - right - left}, 0)`)
      .call(axis)
      .attr('font-size', 12)
  }

  // 绑定横坐标
  bindAxisX() {
    const {
      pane,
      xAxisWrapper,
      xAxis
    } = this
    const {
      height,
      top,
      bottom,
      width,
      left,
      right
    } = this.option
    const axisTextSize = ~~((width - left - right) / 20)
    const axis = d3.axisBottom(xAxis)

    if (!xAxisWrapper) {
      this.xAxisWrapper = pane.append("g")
    }
    this.xAxisWrapper
      .attr('transform', `translate(0, ${height - top - bottom})`)
      .call(axis)
      .attr('font-size', 12)
      
    const textList = this.xAxisWrapper.selectAll('text')

    const textSize = textList.size()

    if (textSize > 15) {
      const interval = ~~(textSize/axisTextSize)
      textList.attr('style', function(v,i) {
        return `transform-origin: 0 0;transform:rotate(-45deg)translate(-35px, -8px);${((i+1)%interval || 0) === 0 ? '': 'display: none'}`
      })
      // textList.attr('style', 'transform-origin: 0 0;transform:rotate(90deg)translate(40px, -12px);')
    }
  }

  insertAxis = () => {
    this.bindAxisX()
    this.bindAxisYBar()
    this.bindAxisYLine()
  }


  render() {

    this.setLayout()

    this.createAxisX()

    this.createBarAxisY()
    this.createLineAxisY()

    this.createBar()
    this.createLine()
    
    const option = this.option
    this.createText(this.pane, 'bar_text', this.xAxis, this.yAxisBar, option.barMap, option.barLabelColor)
    this.createText(this.pane, 'line_text', this.xAxis, this.yAxisLine, option.lineMap, option.lineLabelColor, 'line')

    this.insertAxis()
  }

  reload(opt) {
    Object.assign(this.option, opt)
    this.render()
  }
}


// WEBPACK FOOTER //
// src/chart/multiaxisD3.js